// Status de Pedido de Compra oferecidos nos filtros (listagem do módulo e
// relatório), na ordem do fluxo. "Cancelada" fica por último: sem ela na lista
// não havia como achar os pedidos cancelados. Status que a base ainda tem mas
// o fluxo não usa (ex.: "Finalizado") ficam de fora.
export const STATUS_FILTRO_PEDIDO_COMPRA = [
    'Rascunho',
    'Em Orçamento',
    'Aguardando Aprovação',
    'Aprovado',
    'Rejeitado',
    'Em andamento',
    'Recebida',
    'Concluído',
    'Pendente',
    'Cancelada',
];

/**
 * Filtra e ordena os status devolvidos por GET /pedidos-compra/status para
 * montar o <select> de filtro.
 * @param {Array<{id: number, nome: string}>} status
 */
export const statusParaFiltro = (status) => (Array.isArray(status) ? status : [])
    .filter((s) => STATUS_FILTRO_PEDIDO_COMPRA.includes(s.nome))
    .sort((a, b) => STATUS_FILTRO_PEDIDO_COMPRA.indexOf(a.nome) - STATUS_FILTRO_PEDIDO_COMPRA.indexOf(b.nome));
